export default __webpack_public_path__ + "static/media/fullscreen.5e505c52.svg";